import React from 'react';
import { ContactUsContextProvider } from 'contexts/ContactUsContext';
import ContactUs from 'components/StaticPages/ContactUs';

export default function ContactUsContainer() {
  return (
    <ContactUsContextProvider>
      <ContactUs />
    </ContactUsContextProvider>
  );
}



// WEBPACK FOOTER //
// ./src/components/StaticPages/ContactUsContainer.jsx